// window.MI_CONFIG = { storeName: "Tu Bienestar" }; // reservado para configuración global futura
// window.CHECKOUT_APP = { provider: "releasit" }; // referencia reservada para integraciones de apps de checkout externas
(function () {
  "use strict";

  function onReady(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  onReady(function () {
    var section = document.querySelector(".mcg-section");
    if (!section) return;

    // Reveal de bloques bajo el fold via IntersectionObserver
    var toReveal = section.querySelectorAll(".mcg-benefit, .mcg-howto, .mcg-compare, .mcg-review");
    if ("IntersectionObserver" in window && toReveal.length) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("mcg-inview");
              io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: "0px 0px -10% 0px", threshold: 0.05 }
      );
      toReveal.forEach(function (el) { io.observe(el); });
    }

    // Barra sticky removida: sin barra de "Pedir ahora" fija.

    var codBlock = document.getElementById("mcg-cod");
    var scrollBtn = section.querySelector("[data-mcg-scroll-cod]");
    if (scrollBtn && codBlock) {
      scrollBtn.addEventListener("click", function () {
        var rect = codBlock.getBoundingClientRect();
        var targetY = window.pageYOffset + rect.top - (window.innerHeight - rect.height) / 2;
        window.scrollTo({ top: targetY, behavior: "smooth" });
      });
    }

    // Mini-reseñas: carrusel con dots, avance automático, pausa al interactuar
    var track = section.querySelector(".mcg-quotes__track");
    var dotsWrap = section.querySelector(".mcg-quotes__dots");
    if (track && track.children.length > 1) {
      var qLen = track.children.length;
      var qIdx = 0;
      var timer = null;

      if (dotsWrap) {
        dotsWrap.innerHTML = "";
        for (var d = 0; d < qLen; d++) {
          var dot = document.createElement("span");
          dot.className = "mcg-dot" + (d === 0 ? " is-active" : "");
          dot.addEventListener("click", function (idx) {
            return function () { goTo(idx); restart(); };
          }(d));
          dotsWrap.appendChild(dot);
        }
      }

      function setActiveDot(i) {
        if (!dotsWrap) return;
        var dots = dotsWrap.children;
        for (var k = 0; k < dots.length; k++) dots[k].classList.toggle("is-active", k === i);
      }

      function goTo(i) {
        qIdx = (i + qLen) % qLen;
        track.scrollTo({ left: track.children[qIdx].offsetLeft, behavior: "smooth" });
        setActiveDot(qIdx);
      }

      function restart() {
        clearInterval(timer);
        timer = setInterval(function () { goTo(qIdx + 1); }, 4200);
      }

      var scrollTimeout;
      track.addEventListener("scroll", function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          var mid = track.scrollLeft + track.clientWidth / 2;
          var closest = 0, best = Infinity;
          for (var k = 0; k < qLen; k++) {
            var c = track.children[k];
            var center = c.offsetLeft + c.offsetWidth / 2;
            var dist = Math.abs(center - mid);
            if (dist < best) { best = dist; closest = k; }
          }
          qIdx = closest;
          setActiveDot(qIdx);
        }, 100);
      }, { passive: true });

      track.addEventListener("pointerdown", function () { clearInterval(timer); });
      track.addEventListener("pointerup", restart);

      restart();
    }
  });
})();
